// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__2jYWr","input":"Input_input__222Qm","label":"Input_label__3OjoL","error":"Input_error__2n898"};